import actions from '../../src/router/actions'
import store from '../../src/store'
/**
* @vuese
* This route accessible just by user partnership
*/
const needAuthCompleteAndPartnership = (to, from, next) => {

  // If user owns the world, need phone to be verified
  let phoneOK = false
  if (store.getters['auth/isWorldOwner'] === false) {
    phoneOK = true
  } else if (store.getters['auth/isWorldOwner'] && store.getters['auth/isPhoneVerified']) {
    phoneOK = true
  }

  if (store.getters['auth/isAuthenticated'] && store.getters['auth/isWorldOwner'] && phoneOK && store.getters['auth/getWorld'].modules.partnership) {
    next()
    return
  } else if(store.getters['auth/isAuthenticated'] && !phoneOK) {
    next('/phone_verification')
    return
  }
  // If false
  next('/login')
}

const routes = [
  // Link partnership for Dashboard
  {
    path: '/world/:world/partnership/dashboard',
    name: 'partnership.index',
    component: () => import(/* webpackChunkName: "module-partnership" */ './pages/Dash.vue'),
    beforeEnter: needAuthCompleteAndPartnership,
    meta: {
      icon: 'home4',
      module: true,
      moduleName: "partnership"
    },
    params: {
      module: "partnership"
    }
  },
  // Link partnership for Gestion prospect
  {
    path: '/world/:world/partnership/prospect-management',
    name: 'partnership.prospect_management',
    component: () => import(/* webpackChunkName: "module-partnership" */ './pages/ProspectManagement.vue'),
    beforeEnter: needAuthCompleteAndPartnership,
    meta: {
      icon: 'users4',
      module: true,
      moduleName: "partnership"
    }
  },
  {
    path: '/world/:world/partnership/directory-profile',
    name: 'partnership.directory_profile',
    component: () => import(/* webpackChunkName: "module-partnership" */ './pages/ProfileForm.vue'),
    beforeEnter: needAuthCompleteAndPartnership,
    module: "partnership",
    meta: {
      icon: 'user',
      module: true,
      moduleName: "partnership"
    }
  },
  {
    path: '/world/:world/partnership/preference-directory',
    name: 'partnership.preference_directory',
    component: () => import(/* webpackChunkName: "module-partnership" */ './pages/PreferencAnnuaire.vue'),
    beforeEnter: needAuthCompleteAndPartnership,
    meta: {
      icon: 'cog2',
      module: true,
      moduleName: "partnership"
    }
  },
  {
    path: '/register/:token?',
    name: 'Register',
    component: () => import(/* webpackChunkName: "module-partnership" */ './pages/RegisterForm.vue'),
    beforeEnter: actions.needAnonymous,
    meta: {
      layout: 'anonymous'
    }
  },
];

export default routes
